import Campo from './Campo';
import CartaoCrianca from './CartaoCrianca';
import type { Crianca } from '../types';

interface PassoFilhosProps {
  primeiroNome: string;
  aceiteRegistrado?: string | null;
  criancas: Crianca[];
  erros: Record<string, string>;
  destaques: Record<string, boolean>;
  aoMudar: (indice: number, patch: Partial<Crianca>) => void;
  aoRemover: (indice: number) => void;
  aoAdicionar: () => void;
  contato: string;
  aoMudarContato: (valor: string) => void;
}

const LIMITE_CRIANCAS = 6;
const LETRAS = ['um', 'dois', 'três', 'quatro', 'cinco', 'seis'];

// Passo 2 — um cartão por criança + contato de emergência.
export default function PassoFilhos({
  primeiroNome,
  aceiteRegistrado,
  criancas,
  erros,
  destaques,
  aoMudar,
  aoRemover,
  aoAdicionar,
  contato,
  aoMudarContato,
}: PassoFilhosProps) {
  return (
    <div>
      <h2 className="text-[17px] font-bold text-foreground-950">
        {primeiroNome ? `Olá, ${primeiroNome}!` : 'Seus filhos'}
      </h2>
      <p className="mt-1 text-[15px] leading-relaxed text-foreground-700">
        Conte o que a equipe das crianças precisa saber para cuidar bem deles.
      </p>

      {aceiteRegistrado && (
        <div className="mt-4 rounded-xl border border-success-200 bg-success-50 p-3.5">
          <p className="flex items-start gap-2 text-[14px] leading-relaxed text-success-900">
            <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
              <i className="ri-checkbox-circle-line" aria-hidden />
            </span>
            <span>
              Você já enviou: {aceiteRegistrado}. Pode corrigir e enviar de novo.
            </span>
          </p>
        </div>
      )}

      <div className="mt-4 space-y-3">
        {criancas.map((crianca, indice) => (
          <CartaoCrianca
            key={crianca.chave}
            indice={indice}
            crianca={crianca}
            erros={erros}
            destacada={Boolean(destaques[crianca.chave])}
            aoMudar={(patch) => aoMudar(indice, patch)}
            aoRemover={indice > 0 ? () => aoRemover(indice) : undefined}
          />
        ))}
      </div>

      {criancas.length < LIMITE_CRIANCAS && (
        <button
          type="button"
          onClick={aoAdicionar}
          className="aperta mt-3 flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-secondary-300 bg-white px-4 text-[15px] font-semibold text-primary-600"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-add-line" aria-hidden />
          </span>
          Adicionar outra criança
        </button>
      )}
      {criancas.length >= LIMITE_CRIANCAS && (
        <p className="mt-3 text-[13px] text-foreground-500">
          São {LETRAS[LIMITE_CRIANCAS - 1]} crianças, o máximo por ficha. Se precisar de mais, fale
          com a direção.
        </p>
      )}

      <div className="mt-6 rounded-2xl border border-background-200 bg-white p-4">
        <Campo
          id="campo-contato"
          rotulo="Contato de emergência fora do acampamento"
          valor={contato}
          aoMudar={aoMudarContato}
          placeholder="Nome, parentesco e telefone de alguém que não vai estar lá"
          ajuda="Alguém que atenda o telefone enquanto você estiver no acampamento."
        />
      </div>
    </div>
  );
}